export enum OwnershipType {
  Villa = 'villa',
  Hotel = 'hotel',
  Apartment = 'apartment',
  Ground = 'ground',
}
